<!--<div class = 'row m-0 w-100'>

  <div class = 'col-md-4 offset-4 mt-5' *ngIf = '!this.isLogin'>
      <h4>Login</h4>
      <form #myform = "ngForm" (ngSubmit) = "onSubmit(myform)" >

          <div class = 'form-group'>
              <input class = 'form-control' type = "text" name = "username" placeholder = "Username" ngModel>
          </div>
        
          <div class = 'form-group'>
              <input class = 'form-control' type = "password" name = "password" placeholder = "Password" ngModel>
          </div>
          <input class= 'btn btn-outline-info' type = "submit" value = "Login">
      </form>
  </div>


  <div class = 'col-md-4 offset-4 mt-5' *ngIf = 'this.isLogin'>
     
      <h1>You are logged in</h1>
      <button class = 'btn btn-outline-info' (click) = 'logout()'>Log-out</button>
        
  </div>

</div>
-->
<!-- <div class="auth-page-wrapper pt-5" *ngIf = '!this.isLogin'>
    <div class="auth-page-content">
        <div class="container">

            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="card mt-4">
                    
                        <div class="card-body p-4"> 
                            <div class="text-center mt-2">
                                <h5 class="text-primary">Log into Message Portal</h5>
                                <p class="text-muted"></p><br>
                                <span style="color:red;">{{errorMessage}}</span>
                            </div>
                            <div class="p-2 mt-4">
                                <form #myform = "ngForm" (ngSubmit)="onSubmit(myform)" ngNativeValidate>
    
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Username</label>
                                        <input type="text" class="form-control" required id="username" name="username" placeholder="Enter username" ngModel autocomplete="off">
                                    </div>
            
                                    <div class="mb-3">
                                        <label class="form-label" for="password-input">Password</label>
                                            <input type="password" class="form-control pe-5" required placeholder="Enter password" id="password-input" name="password" ngModel>
                                    </div>
                                    
                                    <div class="mt-4">
                                     <input type="submit" class="btn btn-success w-100" name="login" value="Sign in"/>
                                    </div>
                                    <hr />
                                    <div class="mt-4">
                                        <a class="btn btn-primary w-100" (click)= "navregister()">Create Account</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                   

                </div>
            </div>
        </div>
    </div>
</div> -->
<style>.c{text-align: center;display: block;position: relative;width:80%;margin:100px auto;}._404{font-size: 220px;position: relative;display: inline-block; z-index: 2;height: 100px;letter-spacing: 15px;}._1{text-align:center;display:block;position:relative;letter-spacing: 2px;font-size: 2em;line-height: 80%;}</style>
<div class='c'>
    <div class='_404'></div>
    <div class='_1'>Page Loading... </div>
</div>